"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// const { Fragment } = React
// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Methods
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** [description] */


var MediaState = function MediaState(_ref) {
  var fx = _ref.useMediaQuery,
      children = _ref.children,
      _ref$className = _ref.className,
      givenClassName = _ref$className === void 0 ? '' : _ref$className,
      mediaState = _ref.mediaState,
      updateMediaState = _ref.updateMediaState,
      useEffect = _ref.useEffect,
      useState = _ref.useState,
      client = _ref.client,
      _ref$screenSizeState = _ref.screenSizeState,
      screenSizeState = _ref$screenSizeState === void 0 ? undefined : _ref$screenSizeState,
      _ref$updateScreenSize = _ref.updateScreenSizeState,
      updateScreenSizeState = _ref$updateScreenSize === void 0 ? undefined : _ref$updateScreenSize,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["useMediaQuery", "children", "className", "mediaState", "updateMediaState", "useEffect", "useState", "client", "screenSizeState", "updateScreenSizeState"]); // Defaults


  var screenWidth = 1440;
  var screenHeight = 900; // Defs

  var isExtraLargeDesktop = fx({
    minWidth: 2560
  });
  var isLargeDesktop = fx({
    minWidth: 1920,
    maxWidth: 2559
  });
  var isDesktop = fx({
    minWidth: 1024,
    maxWidth: 1919
  });
  var isTablet = fx({
    minWidth: 768,
    maxWidth: 1023
  });
  var isMobile = fx({
    maxWidth: 767
  });
  var isAsHighAsMyImac = fx({
    minHeight: 1440
  });
  var isTwoThirdsAsHighAsMyImac = fx({
    minHeight: 950,
    maxHeight: 1439
  });
  var isHalfAsHighAsMyImac = fx({
    minHeight: 720,
    maxHeight: 949
  });
  var isOneThirdAsHighAsMyImac = fx({
    minHeight: 480,
    maxHeight: 719
  });
  var isFourthAsHighAsMyImac = fx({
    minHeight: 360,
    maxHeight: 479
  });
  var isVeryShortWhenComparedToMyImac = fx({
    maxHeight: 359
  });
  var isPortrait = fx({
    orientation: 'portrait'
  });
  var isRetina = fx({
    minResolution: '2dppx'
  }); // Classname

  var className = (0, _classnames["default"])(givenClassName, {
    'is-media-aware': true,
    'is-extra-large-desktop': isExtraLargeDesktop,
    'is-large-desktop': isLargeDesktop,
    'is-desktop': isDesktop,
    'is-tablet': isTablet,
    'is-mobile': isMobile,
    'is-as-high-as-my-imac': isAsHighAsMyImac,
    'is-two-thirds-as-high-as-my-imac': isTwoThirdsAsHighAsMyImac,
    'is-half-as-high-as-my-imac': isHalfAsHighAsMyImac,
    'is-one-third-as-high-as-my-imac': isOneThirdAsHighAsMyImac,
    'is-fourth-as-high-as-my-imac': isFourthAsHighAsMyImac,
    'is-very-short-when-compared-to-my-imac': isVeryShortWhenComparedToMyImac,
    'is-portrait': isPortrait,
    'is-retina': isRetina,
    'is-client': client
  });
  useEffect(function () {
    if (typeof window !== 'undefined') {
      ;
      var _window = window;
      screenWidth = _window.innerWidth;
      screenHeight = _window.innerHeight;
    }

    var newMediaState = {
      isExtraLargeDesktop: isExtraLargeDesktop,
      isLargeDesktop: isLargeDesktop,
      isDesktop: isDesktop,
      isTablet: isTablet,
      isMobile: isMobile,
      isAsHighAsMyImac: isAsHighAsMyImac,
      isHalfAsHighAsMyImac: isHalfAsHighAsMyImac,
      isFourthAsHighAsMyImac: isFourthAsHighAsMyImac,
      isVeryShortWhenComparedToMyImac: isVeryShortWhenComparedToMyImac,
      isPortrait: isPortrait,
      isRetina: isRetina,
      currentWidth: isExtraLargeDesktop === true ? 'isExtraLargeDesktop' : isLargeDesktop === true ? 'isLargeDesktop' : isDesktop === true ? 'isDesktop' : isTablet === true ? 'isTablet' : 'isMobile',
      currentHeight: isAsHighAsMyImac === true ? 'isAsHighAsMyImac' : isTwoThirdsAsHighAsMyImac === true ? 'isTwoThirdsAsHighAsMyImac' : isHalfAsHighAsMyImac === true ? 'isHalfAsHighAsMyImac' : isOneThirdAsHighAsMyImac === true ? 'isOneThirdAsHighAsMyImac' : isFourthAsHighAsMyImac === true ? 'isFourthAsHighAsMyImac' : 'isVeryShortWhenComparedToMyImac',
      screenWidth: screenWidth,
      screenHeight: screenHeight
    };
    updateMediaState(_extends({}, mediaState, newMediaState));
  }, [isExtraLargeDesktop, isLargeDesktop, isDesktop, isTablet, isMobile, isAsHighAsMyImac, isTwoThirdsAsHighAsMyImac, isHalfAsHighAsMyImac, isOneThirdAsHighAsMyImac, isFourthAsHighAsMyImac, isVeryShortWhenComparedToMyImac, isPortrait, isRetina, screenWidth, screenHeight]);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: className
  }, otherProps), children);
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = MediaState;
exports["default"] = _default;
module.exports = exports.default;